import {GridHeader} from '@logistics-frontend/blocks/lpc/grid-header'
import {EstimateResponse} from '@yandex-taxi/js-integration-api'
import React from 'react'

type Props = {
  data: EstimateResponse
}

const SuccessText: React.FC<Props> = ({data}) =>
  data.alert ? (
    <GridHeader xs={12} item>
      {data.alert.description}
    </GridHeader>
  ) : null

export default SuccessText
